import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { bool, func, string } from 'prop-types';
import classnames from 'classnames';
import './PulseCard.scss';

PulseCard.propTypes = {
  description: string,
  isIncompatibleCurrency: bool,
  imagePath: string,
  setShowCurrencyModal: func,
  title: string,
  url: string
};

function PulseCard(props) {
  const { description, isIncompatibleCurrency, imagePath, setShowCurrencyModal, title, url } = props;
  const dataTestId = title.toLowerCase().replace(/\s+/g, '-');
  const isAbsoluteUrl = url.includes('http');

  function handleClick(e) {
    if (isIncompatibleCurrency) {
      e.preventDefault();
      setShowCurrencyModal(true);
    }
  }

  function renderCardBody() {
    return (
      <Fragment>
        <img alt={title} className="pulse-card__image" src={imagePath} />
        <h2 className="pulse-card__title">{title}</h2>
        <p className="pulse-card__description">{description}</p>
      </Fragment>
    );
  }

  return (
    <Fragment>
      {isAbsoluteUrl ? (
        <a className="pulse-card" data-test-id={dataTestId} href={url} target="_blank">
          {renderCardBody()}
        </a>
      ) : (
        <Link className="pulse-card" onClick={handleClick} to={url} data-test-id={dataTestId}>
          {renderCardBody()}
        </Link>
      )}
    </Fragment>
  );
}

export default PulseCard;
